module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Ha-Ib.ca11f84f.png";